import React, { useEffect } from "react";
import "../styles/StaticPages.css";

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sp-root">
      <div className="sp-container">
        <div className="sp-header">
          <div className="sp-chip">Legal</div>
          <h1 className="sp-title">Terms & Conditions</h1>
          <p className="sp-sub">
            Last Updated: February 24, 2026 <br />
            Welcome to Easyworld Online. By using our services, you agree to the terms below.
          </p>
        </div>

        <div className="sp-card">

          <div className="sp-section">
            <p className="sp-section-text">
              Welcome to Easyworld Online (“Easyworld”, “we”, “us”, “our”). These Terms & Conditions
              (“Terms”) govern your access and use of our website, services, ordering, and delivery
              of products from Nepal to destinations worldwide. By using our Services, you agree to these Terms.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">1. Acceptance of Terms</h2>
            <p className="sp-section-text">
              These Terms constitute a legally binding agreement between you and Easyworld.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">2. Eligibility</h2>
            <p className="sp-section-text">
              You must be at least 18 years old or have legal authority to enter into binding contracts.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">3. Account Registration</h2>
            <p className="sp-section-text">
              You are responsible for maintaining the confidentiality of your account and all activities under it.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">4. Products, Orders & Pricing</h2>
            <p className="sp-section-text">
              All product descriptions are for informational purposes only. Prices may change, and errors may be corrected at any time.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">5. Payment</h2>
            <p className="sp-section-text">
              Full payment must be received before orders are processed and dispatched.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">6. Shipping & Delivery</h2>
            <p className="sp-section-text">
              Delivery times are estimates only and may vary. Risk passes to you upon delivery. 
              Any applicable customs duties, taxes, or import charges are the responsibility of the customer.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">7. Returns, Refunds & Cancellations</h2>
            <p className="sp-section-text">
              Returns, refunds, and cancellations are subject to our Shipping & Returns Policy.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">8. Intellectual Property</h2>
            <p className="sp-section-text">
              All content on Easyworld Online is owned by or licensed to Easyworld and is protected by applicable intellectual property laws.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">9. User Conduct</h2>
            <p className="sp-section-text">
              You agree not to misuse the Services or engage in any unlawful activity while using the platform.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">10. Limitation of Liability</h2>
            <p className="sp-section-text">
              Our liability is limited to the amount paid for the product or service purchased through our platform.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">11. Indemnification</h2>
            <p className="sp-section-text">
              You agree to indemnify and hold Easyworld harmless from any claims, damages, or losses arising from your use of the Services.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">12. Governing Law</h2>
            <p className="sp-section-text">
              These Terms are governed by the laws of Australia.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">13. Amendments</h2>
            <p className="sp-section-text">
              We may update these Terms at any time by posting the revised version on our website.
              Continued use of the Services constitutes acceptance of the updated Terms.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">14. Contact</h2>
            <p className="sp-section-text">
              Contact details are available on our website for any questions regarding these Terms.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}